import {
  cleanFloat,
  type RoundingMode,
  roundTo,
} from "@/lib/tool-kit/grades/rounding";

/**
 * The easy grader chart: for a test of `total` questions (or points), the score for
 * every possible number wrong — what the classic cardboard slide chart shows.
 *
 * score = (total − wrong) ÷ total × 100, rounded the way the teacher chooses.
 */

export interface EasyGraderRow {
  wrong: number;
  correct: number;
  /** The score as displayed: already rounded to the chosen places. */
  score: number;
}

/** Larger than any real test; keeps a mistyped "2000" from drawing 4,001 rows. */
export const EASY_GRADER_MAX_TOTAL = 300;

export function easyGraderRows(
  total: number,
  step: number,
  decimals: number,
  mode: RoundingMode
): EasyGraderRow[] {
  const rows: EasyGraderRow[] = [];
  const count = Math.floor(cleanFloat(total / step));
  for (let index = 0; index <= count; index += 1) {
    const wrong = cleanFloat(index * step);
    const correct = cleanFloat(total - wrong);
    rows.push({
      wrong,
      correct,
      score: roundTo((correct * 100) / total, decimals, mode),
    });
  }
  return rows;
}

/** Split the chart into columns of `size` rows, for a slide-chart layout and print. */
export function chunkRows<T>(rows: readonly T[], size: number): T[][] {
  const chunks: T[][] = [];
  for (let start = 0; start < rows.length; start += size) {
    chunks.push(rows.slice(start, start + size));
  }
  return chunks;
}
